<template>
  <div id="app" class="d-flex h-100 flex-column scrollable">
    <!-- nav bar -->
    <div class="container-fullwidth">
      <b-modal id="poemmessage" title="LANTERN message" hide-header-close ok-only>The POEM panel will be available soon...</b-modal>
      <b-navbar toggleable="lg" type="dark" variant="primary">
        <b-navbar-brand href="/lantern/">LANTERN</b-navbar-brand>
        <b-navbar-nav v-if="this.$route.path === '/'" class="ml-auto">
          <b-nav-item href="#" active v-on:click="changeDb()">Switch DB</b-nav-item>
          <b-nav-item to="/" active v-on:click="setPoem()">POEM</b-nav-item>
          <b-nav-item-dropdown text="Menu" right>
            <b-dropdown-item to="/about">About</b-dropdown-item>
            <!-- b-dropdown-item href="/#/overview">System Overview</b-dropdown-item -->
            <b-dropdown-item to="/datasets">Datasets</b-dropdown-item>
            <b-dropdown-item to="/guide">User Guide</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item href="#" active v-on:click="changeDb()">Switch DB</b-nav-item>
          <b-nav-item to="/" active v-on:click="setPoem()">POEM</b-nav-item>
          <b-nav-item to="/guide" active>Guide</b-nav-item>-->
        </b-navbar-nav>
      </b-navbar>
    </div>
    <!-- router -->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'app',
  data: function () {
    return {
      showOverlay: false,
      treenodes: {}
    }
  },
  created() {
    // goto login page by default, if user logged in already, go to main page
    if (localStorage.db) {
      // load the db from local storage to vuex store (to make it reactive)
      this.setEmail(localStorage.email)
      this.setDb(localStorage.db)
      this.$router.replace('/', () => {})
    } else {
      this.$router.replace('/login', () => {})
    }
  },
  computed: {
    ...mapState(['db'])
  },
  watch: {
    db(newVal, oldVal) {
      this.$bvToast.toast('Switched to ' + newVal.toUpperCase() + ' database', {
        title: `Database changed`,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        appendToast: true,
        autoHideDelay: 2000
      })
    }
  },
  methods: {
    changeDb() {
      let currDb = this.db
      if (currDb === 'tpch') {
        this.setDb('imdb')
      } else if (currDb === 'imdb') {
        this.setDb('tpch')
      }
    },
    setPoem() {
      this.$bvModal.show('poemmessage')
    },
    ...mapActions(['setDb']),
    ...mapMutations(['setEmail'])
  }
}
</script>
